import { Reveal } from "./Reveal";

export const About = () => (
  <section id="story" className="py-32 md:py-48">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid md:grid-cols-12 gap-16 items-start">
        <div className="md:col-span-3">
          <Reveal>
            <span className="gt-eyebrow">01 — The Story</span>
          </Reveal>
        </div>
        <div className="md:col-span-9">
          <Reveal>
            <h2 className="font-serif font-light leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl text-[var(--gt-ivory)]">
              For over a decade, Marisol has practised
              <span className="gt-gold-text italic"> the art of intentional touch</span> —
              healing that meets the body exactly where it is.
            </h2>
          </Reveal>
          <div className="mt-16 grid sm:grid-cols-2 gap-12 max-w-3xl">
            <Reveal delay={0.1}>
              <p className="text-[15px] leading-relaxed text-[var(--gt-muted)]">
                Every session is shaped around you. No two bodies carry tension alike, so no
                two treatments are the same — each is composed in the moment, guided by
                experience and a deep respect for your comfort.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="text-[15px] leading-relaxed text-[var(--gt-muted)]">
                The Golden Touch is dedicated to all body types and sizes. This is a space of
                warmth, discretion and genuine care — where releasing stress becomes a ritual
                rather than a routine.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
